const baseRoutes = [
    {
        path: '/',
        name: 'Landing',
        component: () => import('./components/search/landing.vue'),
        meta: {
            layout: "Frameless"
        }
    },
    {
        path: '/restaurants/:query',
        name: 'Restaurants',
        component: () => import('./components/search/restaurants.vue'),
        meta: {
            layout: "Frameless"
        }
    },
    {
        path: '/area/:major',
        name: 'AreaMajor',
        component: () => import('./components/search/area.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/area/:major/:minor',
        name: 'AreaMinor',
        component: () => import('./components/search/area.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/sitemap',
        name: 'Sitemap',
        component: () => import('./components/info/sitemap.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/app/info/privacy',
        name: 'AppPrivacy',
        component: () => import('./components/info/legal/privacy/appPrivacy.vue'),
        meta: {
            layout: "Frameless"
        }
    },
    {
        path: '/app/info/terms',
        name: 'AppTerms',
        component: () => import('./components/info/legal/terms/appTerms.vue'),
        meta: {
            layout: "Frameless"
        }
    },
    {
        path: '/business',
        name: 'Business',
        component: () => import('./components/business/business.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/business/enquiry',
        name: 'BusinessEnquiry',
        component: () => import('./components/business/enquiry.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/info/legal',
        name: 'Legal',
        component: () => import('./components/info/legal/legal.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/info/privacy',
        name: 'Privacy',
        component: () => import('./components/info/legal/privacy/privacy.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/info/terms',
        name: 'Terms',
        component: () => import('./components/info/legal/terms/terms.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/info/cookies',
        name: 'Cookies',
        component: () => import('./components/info/legal/cookies/cookies.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/info/delete-my-data',
        name: 'Data',
        component: () => import('./components/info/legal/data/data.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/info/faq',
        name: 'Faq',
        component: () => import('./components/info/faq.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/info/contact',
        name: 'Contact',
        component: () => import('./components/info/contact.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/account',
        name: 'Account',
        component: () => import('./components/account/account.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/account/login',
        name: 'Login',
        component: () => import('./components/account/login.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/account/orders',
        name: 'AccountOrders',
        component: () => import('./components/account/orders.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/account/notifications/:id',
        name: 'AccountNotifications',
        component: () => import('./components/account/notifications.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/login/forgot',
        name: 'ForgotLogin',
        component: () => import('./components/account/forgot.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/login/reset/:id',
        name: 'ResetLogin',
        component: () => import('./components/account/reset.vue'),
        meta: {
            layout: "Portal"
        }
    },
    {
        path: '/notfound',
        name: 'NotFound',
        component: () => import("./views/errors/NotFoundView.vue"),
        meta: {
            layout: "Portal"
        }
    },
    //{
    //    path: '/:companySlug',
    //    component: () => import("./components/company/company.vue"),
    //    meta: {
    //        layout: "Store"
    //    },

    //    children: [
    //        {
    //            path: '/:companySlug/',
    //            name: 'Branches',
    //            component: () => import("./components/branch/branches.vue"),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/test',
    //            name: 'CreateTestOrder',
    //            component: () => import('./components/order/createTestOrder.vue'),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/',
    //            name: 'Menu',
    //            component: () => import("./components/menu/menu.vue"),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/:orderType',
    //            name: 'MenuIntention',
    //            component: () => import("./components/menu/menu.vue"),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/contact',
    //            name: 'BranchContact',
    //            component: () => import("./components/branch/contact.vue"),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/checkout/customer',
    //            name: 'CheckoutCustomer',
    //            component: () => import('./components/checkout/customer.vue'),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/checkout/payment',
    //            name: 'CheckoutPayment',
    //            component: () => import('./components/checkout/payment.vue'),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/checkout/success/:id',
    //            name: 'CheckoutSuccess',
    //            component: () => import('./components/checkout/success.vue'),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/order/:orderId',
    //            name: 'Order',
    //            component: () => import('./components/order/order.vue'),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/:orderType/:tableSlug',
    //            name: 'TableMenu',
    //            component: () => import("./components/menu/menu.vue"),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/:orderType/item/:itemId/:itemSlug?',
    //            name: 'ProductDetail',
    //            component: () => import("./components/menu/productDetail.vue"),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/:orderType/item/:itemId/:itemSlug/:tableSlug',
    //            name: 'ProductDetailTable',
    //            component: () => import("./components/menu/productDetail.vue"),
    //            meta: {
    //                layout: "Store"
    //            }
    //        },
    //        {
    //            path: '/:companySlug/:branchSlug/customise/:itemId/:priceId',
    //            name: 'ProductDesigner',
    //            component: () => import('./components/menu/productDesigner.vue'),
    //            meta: {
    //                layout: "Store"
    //            }
    //        }
    //    ]
    //}
    {
        path: '/:companySlug/',
        name: 'Branches',
        component: () => import("./components/branch/branches.vue"),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/test',
        name: 'CreateTestOrder',
        component: () => import('./components/order/createTestOrder.vue'),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/',
        name: 'Menu',
        component: () => import("./components/menu/menu.vue"),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/:orderType',
        name: 'MenuIntention',
        component: () => import("./components/menu/menu.vue"),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/contact',
        name: 'BranchContact',
        component: () => import("./components/branch/contact.vue"),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/checkout/customer',
        name: 'CheckoutCustomer',
        component: () => import('./components/checkout/customer.vue'),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/checkout/payment',
        name: 'CheckoutPayment',
        component: () => import('./components/checkout/payment.vue'),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/checkout/success/:id',
        name: 'CheckoutSuccess',
        component: () => import('./components/checkout/success.vue'),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/order/:orderId',
        name: 'Order',
        component: () => import('./components/order/order.vue'),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/:orderType/:tableSlug',
        name: 'TableMenu',
        component: () => import("./components/menu/menu.vue"),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/:orderType/item/:itemId/:itemSlug?',
        name: 'ProductDetail',
        component: () => import("./components/menu/productDetail.vue"),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/:orderType/item/:itemId/:itemSlug/:tableSlug',
        name: 'ProductDetailTable',
        component: () => import("./components/menu/productDetail.vue"),
        meta: {
            layout: "Store"
        }
    },
    {
        path: '/:companySlug/:branchSlug/customise/:itemId/:priceId',
        name: 'ProductDesigner',
        component: () => import('./components/menu/productDesigner.vue'),
        meta: {
            layout: "Store"
        }
    }
];

const miscRoutes = [
    {
        path: '/:pathMatch(.*)',
        name: 'NotFoundCatchAll',
        component: () => import("./views/errors/NotFoundView.vue"),
        meta: {
            title: "Not Found"
        }
    }
];

const presentation = {
 Landing: () => import('./views/portal/PortalView.vue'), Restaurants: () => import('./views/portal/PortalView.vue'),
 Branches: () => import('./views/store/StoreView.vue'), CreateTestOrder: () => import('./views/store/StoreView.vue'),
 Menu: () => import('./views/menu/MenuView.vue'), MenuIntention: () => import('./views/menu/MenuView.vue'), TableMenu: () => import('./views/menu/MenuView.vue'),
 ProductDetail: () => import('./views/menu/MenuView.vue'), ProductDetailTable: () => import('./views/menu/MenuView.vue'),
 CheckoutCustomer: () => import('./views/checkout/CustomerView.vue'), CheckoutPayment: () => import('./views/checkout/CustomerView.vue'), CheckoutSuccess: () => import('./views/checkout/SuccessView.vue'),
};

const routes = baseRoutes.concat(miscRoutes).map(route => ({
    ...route,
    component: presentation[route.name] || route.component,
    ...(route.name === 'CreateTestOrder' ? { props: { testOrder: true } } : {}),
    path: route.path,
    alias: '/v2' + (route.path === '/' ? '' : route.path),
    name: 'V2' + route.name,
    meta: {
        ...route.meta,
        layout: 'V2',
        v2Layout: route.meta?.layout || 'Default',
        orderingV2: true,
        menuSurface: ['Menu', 'MenuIntention', 'TableMenu', 'ProductDetail', 'ProductDetailTable'].includes(route.name),
        originalRouteName: route.name,
    },
}));

routes.push({ path: '/checkout/return', alias: '/v2/checkout/return', name: 'V2PaymentReturn', component: () => import('./views/checkout/PaymentReturn.vue'), meta: { layout: 'V2', v2Layout: 'Default', orderingV2: true, originalRouteName: 'PaymentReturn' } });

export default {
    routes: routes
}